export class Tag {
  id: string;
  creationDate: Date;
  updateDate: Date;
  tagString: string;
}
